import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import TextArea from '@app/modules/Messages/Components/TextArea/TextArea'
import LawyerChatAction from '@app/modules/Messages/store/actions'
import { LawyerChatState } from '@app/modules/Messages/store/models'

import './styles.scss'

type LawyerChatProps = {
  notes
  showTextAreaError
}

const getLawyerChatState = ({ lawyerChat }: { lawyerChat: LawyerChatState }): LawyerChatProps => ({
  ...lawyerChat
})

export const AddMessage = () => {
  const dispatch = useDispatch()
  const { notes, showTextAreaError } = useSelector(getLawyerChatState)

  return (
    <div className='add-lawyer-documents'>
      <TextArea
        className='add-lawyer-documents__textarea'
        value={notes}
        placeholder='Antwort an Mandanten eingeben'
        maxLength={20000}
        onChange={(notes) => dispatch(LawyerChatAction.addNotes(notes))}
        isControlled
      />
      {showTextAreaError && <div className='document-error'>Bitte füllen Sie dieses Feld aus</div>}
    </div>
  )
}
